import React from "react";
import VideoControlTrack from "./VideoControlTrack";

const VideoControls = () => {
    return (<div className="flex gap-4 absolute right-6 bottom-6 z-10">

        {
            ['camera', 'audio', 'screen'].map(track => <VideoControlTrack key={track} type={track} />)
        }
    </div>)
}

export default VideoControls